export const VoucherStatus = {
  OPEN: 'OPEN',
  REDEEMED: 'REDEEMED',
  REVOKED: 'REVOKED',
  EXPIRED: 'EXPIRED'
} as const

export type VoucherStatus = (typeof VoucherStatus)[keyof typeof VoucherStatus]
